export default __webpack_public_path__ + "static/media/031-ice cream machine.de3871a0.svg";